import { create } from 'zustand';
import type { ReportDoc } from './model';

/**
 * Which report the studio has open: a new one made from an analysis (no id yet) or one saved in a workspace.
 * The studio is mounted once in the layout and shows itself while a report is open.
 */
interface StudioState {
  doc: ReportDoc | null;
  /** Saved as: the workspace and the report's id. */
  saved: { workspace: string; id: string; canUpdate: boolean } | null;
  dirty: boolean;
  openDraft: (doc: ReportDoc) => void;
  openSaved: (doc: ReportDoc, saved: { workspace: string; id: string; canUpdate: boolean }) => void;
  change: (fn: (doc: ReportDoc) => ReportDoc) => void;
  markSaved: (saved: { workspace: string; id: string; canUpdate: boolean }) => void;
  close: () => void;
}

export const useStudio = create<StudioState>((set) => ({
  doc: null,
  saved: null,
  dirty: false,
  openDraft: (doc) => set({ doc, saved: null, dirty: true }),
  openSaved: (doc, saved) => set({ doc, saved, dirty: false }),
  change: (fn) => set((s) => (s.doc ? { doc: fn(s.doc), dirty: true } : s)),
  markSaved: (saved) => set({ saved, dirty: false }),
  close: () => set({ doc: null, saved: null, dirty: false }),
}));
